import { createSelector } from 'reselect'

const pollSelector = state => state.poll

const pollUploadReferenceMediaSelector = createSelector(
	[ pollSelector ],
	pollState => ({
		entityUID: pollState.entityUID,
		presentationId: pollState.presentationId,
	})
)

export default pollUploadReferenceMediaSelector
